import { useDisplayName } from '../../hooks/useDisplayName';

// Phone: the big greeting header every main screen starts with
// ("Hey Alexis / Here's your ... today" plus a few small chips).
// chips: array of strings, or { text, tone: 'up' | 'down' }.
export const PhoneHero = ({ sub, chips = [] }) => {
  const { firstName } = useDisplayName();
  return (
    <div className="m-home-header m-collection-hero">
      <div className="m-home-greet">Hey {firstName || 'there'}</div>
      <div className="m-home-sub">{sub}</div>
      {chips.length > 0 && (
        <div className="m-home-chips">
          {chips.map((c, i) => {
            const chip = typeof c === 'string' ? { text: c } : c;
            return <span key={i} className={`m-chip ${chip.tone === 'up' ? 'is-up' : chip.tone === 'down' ? 'is-down' : ''}`}>{chip.text}</span>;
          })}
        </div>
      )}
    </div>
  );
};
